import { render, staticRenderFns } from "./WhiteCardList.vue?vue&type=template&id=6d78107e"
import script from "./WhiteCardList.vue?vue&type=script&lang=js"
export * from "./WhiteCardList.vue?vue&type=script&lang=js"
import style0 from "./WhiteCardList.vue?vue&type=style&index=0&id=6d78107e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports